import type { ReactNode } from 'react'
import { ExternalLinkIcon } from 'lucide-react'
import { cx } from 'class-variance-authority'
import Icon from './Icon'
import type { LinkProps } from './Link'
import Link from './Link'

export type ExternalLinkProps = LinkProps & {
    children: ReactNode
}

const ExternalLink = ({ children, className, target, ...props }: ExternalLinkProps) => {
    return (
        <Link className={cx(['inline-flex gap-1 items-center', className])} target={target ?? '_blank'} {...props}>
            {children}
            <Icon size={'1'} icon={ExternalLinkIcon} color="positive" />
        </Link>
    )
}

export default ExternalLink
